import { gql } from '@apollo/client';

export const GET_ALL_TMS_CARRIER_BY_WAREHOUSEID = gql`
  query GetAllTmsCarrierByWarehouseId($warehouseId: Long) {
    getAllTmsCarrierByWarehouseId(warehouseId: $warehouseId) {
      id
      carrierName
      status
    }
  }
`;

// TMS 内部专属：warehouseId 必填，原 GET_ALL_TMS_CARRIER_BY_WAREHOUSEID（getAllTmsCarrierByWarehouseId）保持不变，避免影响总部账号管理页等其他调用方
export const GET_TMS_CARRIERS_BY_WAREHOUSE_ID = gql`
  query GetTmsCarriersByWarehouseId($warehouseId: Long!) {
    getTmsCarriersByWarehouseId(warehouseId: $warehouseId) {
      id
      carrierName
      status
    }
  }
`;
